import React from 'react';
import Footer2Component from '../commons/footer2';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

export default class SplashPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            idx: 1,
            contents:
                <div className="row contents">
                    <h1>Jumpstart your Career</h1>
                    <span>We know how hard it is to find professional opportunities,</span>
                    <span>especially while you are launching your career.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span>Sign up for free to get started.</span>
                </div>
        }
    }

    handleClick = (idx, evt) => {
        var contents = this.state.contents
        if (idx == 1) {
            contents =
                <div className="row contents">
                    <h1>Jumpstart your Career</h1>
                    <span>We know how hard it is to find professional opportunities,</span>
                    <span>especially while you are launching your career.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span>Sign up for free to get started.</span>
                </div>
        }
        else if (idx == 2) {
            contents =
                <div className="row contents">
                    <h1>Get paid for your work</h1>
                    <span>Apply to project's, generate income, and work at your own time.</span>
                    <span>&nbsp;</span>
                    <Link className={"btn03"} to="/signup">SIGN UP TO EARN</Link>
                    <span>Learn more about micro-internships</span>
                </div>
        }
        else if (idx == 3) {
            contents =
                <div className="row contents">
                    <h1>Land your dream <br/>job</h1>
                    <span>With Versity, you can build a unique portfolio, gain valuable</span>
                    <span>experience and get hired.</span>
                    <Link className={"btn03"} to="/signup">FIND WORK</Link>
                    <span>Find talent</span>
                </div>
        }
        else if (idx == 4) {
            contents =
                <div className="row contents">
                    <h1>Enhance your skill <br/>set</h1>
                    <span>Enhance your core skills through short term professional</span>
                    <span>assignments that help jumpstart your career.</span>
                    <Link className={"btn03"} to="/signup">SIGN UP</Link>
                    <span>&nbsp;</span>
                </div>
        }
        this.setState({idx: idx, contents: contents})
    }

    render() {
        //console.log('pix 1');
		if (isMobile) {
            return (
                <div id={"response-home-mobile"}>
                    <header>
                        <div className="header">
                            <div className="splash_logo">
                                <Link to="/">
                                    <img alt="VERSITY" src="/static/img/appimg/login_h_logo.png"/>
                                </Link>
                            </div>
                        </div>
                    </header>
                    <Splash_Signin
                        type="0"
                        isMobile={1}
                        openDialog={this.props.openDialog}
                        url="code/apis.php"
                    />
                    <div className={"footerClear"}>&nbsp;</div>
					<Footer2Component/>
                </div>
            )
        }

        let idx = this.state.idx
        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="code/apis.php"/>
                    </div>
                </header>
                <div id="v-splash" className="splash_wrapper">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div onClick={this.handleClick.bind(this, 1)} className={idx == 1? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon01.png"/>
                                <span>Profile</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 2)} className={idx == 2? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon02.png"/>
                                <span>Earn</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 3)} className={idx == 3? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon03.png"/>
                                <span>Work</span>
                            </div>
                            <div onClick={this.handleClick.bind(this, 4)} className={idx == 4? "col-xs-3 text-center active" : "col-xs-3 text-center"}>
                                <img className={"img_logo"} src="/static/img/homeimg/home/hicon04.png"/>
                                <span>Skills</span>
                            </div>
                        </div>
                        {this.state.contents}
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/splash.js
 **/